import { buildEmptyProduct } from 'components/ProductDetails';

export const buildCarouselPlaceholderData = () => {
  return [
    buildEmptyProduct(),
    buildEmptyProduct(),
    buildEmptyProduct(),
    buildEmptyProduct(),
  ];
};
